import { assertNever, noop } from '@kofno/piper';

import { CurrentUserStore } from '../../CurrentUserStore';
import { State } from '../../CurrentUserStore/Types';
import ReactionComponent, { RCProps } from '../../ReactionComponent';
import { handleAnalyticsError, identifyUser } from './Types';

interface Props extends RCProps<CurrentUserStore> {}

export class AnalyticsUserIdentification extends ReactionComponent<CurrentUserStore, State, Props> {
  tester = () => this.props.store.currentUserState;
  effect = (state: State) => {
    switch (state.kind) {
      case 'waiting':
      case 'anonymous':
      case 'unauthorized':
      case 'identifying':
      case 'errored':
        break;
      case 'identified':
      case 'logging-out':
        identifyUser(state).fork(handleAnalyticsError, noop);
        break;
      default:
        assertNever(state);
    }
  };
}
